import { BaseModel } from "@blue-chip/core";

import Project from "./Project";

export default class ProjectType extends BaseModel {
  static get hasMany() {
    return [Project];
  }
}
